<template>
  <div>
    <canvas ref="qrCanvas" style="display: none;"></canvas>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import QRCode from 'qrcode'

export default defineComponent({
  name: 'QrCodeModal',
  props: {
    label: {
      type: String,
      default: 'N/A'
    },
    tinyUrl: {
      type: String,
      default: 'N/A'
    },
    logoName: {
      type: String,
      default: 'N/A'
    },
    width: {
      type: Number,
      default: 400
    }
  },
  async mounted () {
    await this.generateQRCodeWithLogo()
  },
  data () {
    return {
      url: ''
    }
  },
  methods: {
    downloadQRCode () {
      const canvas = this.$refs.qrCanvas as HTMLCanvasElement
      const link = document.createElement('a')
      link.href = canvas.toDataURL('image/png')
      link.download = this.label + '.png'
      link.click()
      this.$emit('download-complete')
    },
    addLogoToQRCode (canvas: HTMLCanvasElement): Promise<void> {
      return new Promise((resolve, reject) => {
        const ctx = canvas.getContext('2d')
        const logo = new Image()
        logo.src = require('@/assets/logos/' + this.logoName)

        logo.onload = () => {
          const logoSize = this.width * 0.2
          const x = (canvas.width - logoSize) / 2
          const y = (canvas.height - logoSize) / 2

          ctx?.drawImage(logo, x, y, logoSize, logoSize)

          resolve()
        }

        logo.onerror = (error) => {
          console.error('>> Error creating QR Code: ', error)
          this.$emit('qrcode-error')
          reject(new Error('Error loading logo image: ' + error))
        }
      })
    },
    async generateQRCodeWithLogo () {
      const canvas = this.$refs.qrCanvas as HTMLCanvasElement

      try {
        await QRCode.toCanvas(canvas, this.tinyUrl, { width: this.width })
      } catch (error) {
        console.error('Error generating QR code:', error)
        return
      }

      try {
        if (this.logoName !== 'N/A') {
          await this.addLogoToQRCode(canvas)
        }
      } catch (error) {
        console.error('Error adding logo to QR code: ', error)
      }

      this.downloadQRCode()
    }
  }
})
</script>
